import React from 'react'

import Svg from './'

const SvgLicenseCpr = props => (
  <Svg viewBox="0 0 100 81.355" {...props}>
    <path d="M74.2,8.34a17.594,17.594,0,0,1,11.966,4.491,16.257,16.257,0,0,1,5.508,12.017,16.254,16.254,0,0,1-5.508,12.016L50,70.05,13.831,36.864A16.254,16.254,0,0,1,8.323,24.848a16.257,16.257,0,0,1,5.508-12.017A17.594,17.594,0,0,1,25.8,8.34a17.594,17.594,0,0,1,11.966,4.491l6.593,6.051,5.627,5.084,5.627-5.084L62.2,12.831A17.594,17.594,0,0,1,74.169,8.34m0-8.339A26,26,0,0,0,56.593,6.7L50,12.746,43.407,6.7A26,26,0,0,0,25.8,0,26,26,0,0,0,8.2,6.7a24.208,24.208,0,0,0,0,36.321L50,81.355,91.8,43.017A24.2,24.2,0,0,0,91.8,6.7,26,26,0,0,0,74.2,0Z" />
  </Svg>
)

export default SvgLicenseCpr



// WEBPACK FOOTER //
// ../source/components/Svg/SvgLicenseCpr.js